import script from "./productFileDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./productFileDialog.vue?vue&type=script&setup=true&lang=js"

import "./productFileDialog.vue?vue&type=style&index=0&id=1df5a8d0&lang=css"

const __exports__ = script;

export default __exports__